import { Link } from 'wouter'
import { Flame } from 'lucide-react'
import { PLATFORM_NAME, PLATFORM_DOMAIN } from '@/lib/constants'

export default function UserLayout({ children }: { children: React.ReactNode }) {
  return (
    <div className="min-h-screen bg-background">
      {/* Minimal top nav */}
      <header className="fixed top-0 inset-x-0 z-50 h-14 border-b border-border/50 bg-background/80 backdrop-blur-md flex items-center px-6">
        <Link href="/get-started" className="flex items-center gap-2.5 mr-auto">
          <div className="w-7 h-7 rounded-md lava-gradient flex items-center justify-center">
            <Flame className="w-3.5 h-3.5 text-lava-foreground" />
          </div>
          <span className="text-sm font-semibold text-foreground">{PLATFORM_NAME}</span>
        </Link>

        <nav className="flex items-center gap-1">
          <Link
            href="/playground"
            className="px-3 py-1.5 text-sm text-muted-foreground hover:text-foreground transition-colors rounded-md hover:bg-muted/60"
          >
            SQL Console
          </Link>
          <Link
            href="/portal"
            className="px-3 py-1.5 text-sm text-muted-foreground hover:text-foreground transition-colors rounded-md hover:bg-muted/60"
          >
            My Portal
          </Link>
          <Link
            href="/login"
            className="ml-2 px-3 py-1.5 text-sm font-medium text-foreground bg-muted rounded-md hover:bg-muted/80 transition-colors border border-border"
          >
            Sign in
          </Link>
        </nav>
      </header>

      <div className="pt-14">
        {children}
      </div>

      <footer className="border-t border-border/50 mt-24 py-8 px-6 text-center">
        <p className="text-xs text-muted-foreground">
          &copy; {new Date().getFullYear()} {PLATFORM_NAME} &middot; {PLATFORM_DOMAIN} &middot; Powered by Cloudflare Edge
        </p>
      </footer>
    </div>
  )
}
